import React, { useRef, useState, useLayoutEffect } from 'react';
import { Box } from '@mui/material';

export default function Component(props) {
  const { data, itemWidth } = props;
  const boxRef = useRef(null);
  const [boxWidth, setBoxWidth] = useState(100);

  useLayoutEffect(() => {
    setBoxWidth(boxRef.current.offsetWidth);
  });

  return (
    <Box
      display="flex"
      whiteSpace="nowrap"
      gap={1}
      px={2}
      overflow="auto"
      sx={{
        '::-webkit-scrollbar': {
          display: 'none',
        },
      }}
      ref={boxRef}
    >
      {data.map((asset, index) => (
        <Box display="inline-flex" key={index}>
          <img src={asset} alt="testasset" style={{ width: boxWidth * itemWidth, objectFit: 'cover' }} />
        </Box>
      ))}
    </Box>
  );
}
